import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@/components/ui/carousel';

const TestimonialSlider = () => {
    const testimonials = [
        {
            name: 'María González',
            role: 'Compradora de Primera Vivienda',
            image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80',
            rating: 5,
            text: 'Excelente servicio. Me ayudaron a encontrar la casa de mis sueños en Santa Ana. El equipo fue muy profesional y atento durante todo el proceso.'
        },
        {
            name: 'Carlos Martínez',
            role: 'Inversionista Inmobiliario',
            image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80',
            rating: 5,
            text: 'La mejor inversión que he hecho. Servicios Futura me asesoró perfectamente y ahora tengo propiedades rentables en excelentes ubicaciones.'
        },
        {
            name: 'Ana Rodríguez',
            role: 'Vendedora de Propiedad',
            image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80',
            rating: 5,
            text: 'Proceso rápido y transparente. Vendieron mi casa en tiempo récord y al precio que yo esperaba. Totalmente recomendados.'
        },
        {
            name: 'Roberto Sánchez',
            role: 'Cliente de Alquiler',
            image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80',
            rating: 5,
            text: 'Encontraron el local comercial perfecto para mi negocio. Entendieron mis necesidades desde el primer día.'
        }
    ];

    return (
        <div className="w-full max-w-6xl mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {testimonials.slice(0, 3).map((testimonial, index) => (
                    <Card key={index} className="border-none shadow-lg hover:shadow-xl transition-shadow bg-white">
                        <CardContent className="p-8 flex flex-col items-center text-center h-full">
                            <div className="w-16 h-16 rounded-full overflow-hidden mb-6 border-2 border-secondary">
                                <img
                                    src={testimonial.image}
                                    alt={testimonial.name}
                                    className="w-full h-full object-cover"
                                />
                            </div>

                            <div className="flex mb-4 text-yellow-400">
                                {[...Array(testimonial.rating)].map((_, i) => (
                                    <Star key={i} size={16} fill="currentColor" />
                                ))}
                            </div>

                            <p className="text-gray-600 italic mb-6 flex-grow">
                                "{testimonial.text}"
                            </p>

                            <div>
                                <h4 className="font-bold text-primary text-lg">{testimonial.name}</h4>
                                <p className="text-sm text-secondary font-medium">{testimonial.role}</p>
                            </div>
                        </CardContent>
                    </Card>
                ))}
            </div>
        </div>
    );
};

export default TestimonialSlider;
